import DapDSOptionList from './option-list.component'

export * from './option-list.component'
export default DapDSOptionList

DapDSOptionList.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-option-list': DapDSOptionList
  }
}
